import { InjectionToken } from '@angular/core';
import { SearchActionHandler } from '../models/search-action.model';

/**
 * Multi-provider token. Each domain module registers handlers for the
 * action types it owns (e.g. Settings handles 'navigate', Permissions
 * handles 'select-in-dialog'). SearchActionDispatcher routes by type.
 */
export const SEARCH_ACTION_HANDLER = new InjectionToken<SearchActionHandler>(
  'SEARCH_ACTION_HANDLER'
);
